import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessRoute } from '../../auth/roles';

export default function RequireRole({
  children,
  path,
}: {
  children: React.ReactNode;
  path: string;
}) {
  const { appUser, loading } = useAuth();

  if (loading) {
    return <div className="login-page">Carregando...</div>;
  }

  if (!localStorage.getItem('jwt_token') || !appUser) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessRoute(appUser.role, path)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
